import { jsx as r } from "react/jsx-runtime";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import s from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import c from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import f from "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import d from "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import l from "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import h from "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import k from "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
const b = c(
  (o) => s({
    container: {
      width: "100%",
      [o.breakpoints.up("sm")]: {
        maxWidth: "328px"
      }
    }
  })
), Jt = ({
  msg: o,
  withoutIcon: m = !1,
  variant: p = "filled",
  severity: i = "success",
  ...e
}) => {
  const a = b(), n = { variant: p, severity: i };
  let t = !1;
  if (!m)
    switch (i) {
      case "error":
        t = /* @__PURE__ */ r(d, { "data-testid": "icon-error", fontSize: "inherit" });
        break;
      case "info":
        t = /* @__PURE__ */ r(l, { "data-testid": "icon-info", fontSize: "inherit" });
        break;
      case "warning":
        t = /* @__PURE__ */ r(h, { "data-testid": "icon-warning", fontSize: "inherit" });
        break;
      default:
        t = /* @__PURE__ */ r(f, { "data-testid": "icon-success", fontSize: "inherit" });
        break;
    }
  return /* @__PURE__ */ r(
    k,
    {
      "data-testid": "app-snackbar",
      className: a.container,
      icon: t,
      ...n,
      ...e,
      children: o
    }
  );
};
export {
  Jt as default
};
//# sourceMappingURL=Snackbar.js.map
